import { useFormContext } from 'react-hook-form';
import FormFieldComponent from './FormFieldComponent';
import { Check, X } from 'lucide-react';
export const errorList = [
  {
    label: 'Contains one lowercase letter',
    message: 'LOWERCASE',
    regex: /[a-z]/,
  },
  {
    label: 'Contains one uppercase letter',
    message: 'UPPERCASE',
    regex: /[A-Z]/,
  },
  {
    label: 'Contains one number',
    message: 'NUMBER',
    regex: /[0-9]/,
  },
  {
    label: 'Contains one special character',
    message: 'SPECIAL_CHAR',
    regex: /[^A-Za-z0-9]/,
  },
  {
    label: 'Minimum 8 characters',
    message: 'MIN_CHARS',
    regex: /.{8,}/,
  },
];

export const ChangePassword = () => {
  const {
    control,
    trigger,
    watch,
    formState: { dirtyFields },
  } = useFormContext();
  const password = watch('newPassword') as string;
  return (
    <div className="flex flex-col gap-4">
      <FormFieldComponent
        control={control}
        name="newPassword"
        label="Create New Password"
        placeholder="Enter New Password"
        required
        type="password"
        onChange={() => trigger('newPassword')}
      />
      <div>
        {errorList.map((el, index) => (
          <div className="flex justify-start " key={index}>
            <p
              className={`text-sm flex flex-row gap-4 ${!dirtyFields.newPassword ? 'text-placeholder' : `${!el.regex.test(password) || !password ? 'text-error' : 'text-[#1B8652]'}`} `}
            >
              {!el.regex.test(password) || !password ? (
                <X className={`w-4 h-4  ${!dirtyFields.newPassword ? 'text-placeholder' : 'text-error'}`} />
              ) : (
                <Check className="w-4 h-4 text-[#1B8652]" />
              )}{' '}
              {el.label}
            </p>
          </div>
        ))}
      </div>
      <FormFieldComponent
        control={control}
        name="retypeNewPassword"
        label="Re-Enter New Password"
        placeholder="Re-Enter Password"
        required
        type="password"
      />
    </div>
  );
};
